module.exports = __webpack_public_path__ + "img/user_circle.0f8e789e.jpeg";